import { createConsumer, type Consumer } from '@rails/actioncable'

// One WebSocket for the streams that live as long as the tab does (the bell
// and presence). Each extra createConsumer is another socket and another
// handshake on every reconnect.
let consumer: Consumer | null = null

export function sharedConsumer(): Consumer {
  consumer ??= createConsumer('/cable')
  return consumer
}
